export const iconFontAwesomeMapsMoneyBill1 = (
	<i className="fa-solid fa-money-bill-1"></i>
);
